import { CARGO_ROW_TYPE_LABEL, LTL_FAMILY_CARGO_TYPES, TCargoRow } from '@types';

/* Every distinct type present, in canonical order, joined by "/" - "Bundle/Pallet" for a mixed
   shipment, or just "Pallet" when every row shares one type. */
export const getCargoTypeListLabel = (rows: TCargoRow[]): string => {
	return LTL_FAMILY_CARGO_TYPES
		.filter((type) => rows.some((row) => row.type === type))
		.map((type) => CARGO_ROW_TYPE_LABEL[type])
		.join('/');
};
